import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportFuncionarioTreinamentoTercUseCase } from "../../../presentation/useCases/read/get_report_funcionario_treinamento_terc_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportFuncionarioTreinamentoTercUseCase implements IGetReportFuncionarioTreinamentoTercUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportFuncionarioTreinamentoTerc(
    requiredMimeType: ReportMimeType | null, idFuncionarioTreinamento: number
  ): Promise<ReportData> {
    const response = await this.repository.getReportFuncionarioTreinamentoTerc(
      requiredMimeType, idFuncionarioTreinamento
    );

    if (response.mimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `Lista_Funcionarios_Terceirizados_${idFuncionarioTreinamento}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
